import React from 'react';

const UpcomingEvents = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.66406 4.16764C1.66406 3.70729 2.03725 3.33411 2.4976 3.33411H17.5012C17.9616 3.33411 18.3347 3.70729 18.3347 4.16764V15.8371C18.3347 17.2182 17.2152 18.3377 15.8341 18.3377H4.16466C2.78362 18.3377 1.66406 17.2182 1.66406 15.8371V4.16764Z",
      stroke: "white",
      strokeWidth: "1.2503"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.83594 5.41767V1.25",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.1719 5.41767V1.25",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.66406 7.50165H18.3347",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "4.58594",
      y: "10.8358",
      width: "2.5006",
      height: "2.5006",
      rx: "0.416767",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "8.75",
      y: "10.8358",
      width: "2.5006",
      height: "2.5006",
      rx: "0.416767",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "12.9141",
      y: "10.8358",
      width: "2.5006",
      height: "2.5006",
      rx: "0.416767",
      fill: "white"
    }
  )
);

export { UpcomingEvents };
//# sourceMappingURL=UpcomingEvents.js.map
